<template>
    <hts-drawer
        v-model="visible"
        :rules="rules"
        :submit="handleSubmit"
        :title="$t('labels.createApiKey')"
        @close="close">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-form-input
                v-model="form.name"
                :label="$t('labels.name')"
                required
                name="name"
                prop="name" />

            <hts-form-ip
                v-model="form.allowedIps"
                :label="$t('labels.allowedIps')" />
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
const { $t } = useNuxtApp()

const visible = ref(false)

const emits = defineEmits(['close', 'refreshTables', 'newPartner'])

const close = () => {
  visible.value = false
  reset()
}

const form = ref({
  name: '',
  allowedIps: [] as string[] // Chuỗi các IP, cách nhau bởi dấu phẩy
})

const open = (types?: string | [string]) => {
  visible.value = true
}
defineExpose({
  open
})

const reset = () => {
  form.value.name = ''
  form.value.allowedIps = []
}

const handleSubmit = () => {
  const api = $url.company.api_key.create

  $api(api, { body: { name: form.value.name, allowedIps: form.value.allowedIps } }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      process.client && $toast().success('Tạo api key thành công')
      emits('refreshTables')
      close()
    }
  })
}

const rules = computed(() => {
  return {
    name: 'required'
  }
})
</script>
